/* eslint no-console: 0 */
// Add "= javascript_pack_tag 'browse_tests'" to the haml file to use this

import Vue from 'vue/dist/vue.esm'

document.addEventListener('DOMContentLoaded', () => {
  const default_cookie = { perPage: 8, sort_by: "published_DESC", filter_by_test_or_sample:"", filter_by_craft: "",
    filter_by_category: "", filter_by_language: "", filter_by_flexible_deadline: "",
    filter_by_difficulty: [ "0", "1", "2", "3", "4" ], filter_by_tech_edited: "" };

  const browse_tests_vue = new Vue({
    el: '#browse_tests',
    data: {
      open_tests: [],
      page: 1,
      perPage: ($cookies.get('all_tests_filters') || default_cookie).perPage,
      pages: [],
      sort_by: ($cookies.get('all_tests_filters') || default_cookie).sort_by,
      filter_by_test_or_sample: ($cookies.get('all_tests_filters') || default_cookie).filter_by_test_or_sample,
      filter_by_craft: ($cookies.get('all_tests_filters') || default_cookie).filter_by_craft,
      filter_by_category: ($cookies.get('all_tests_filters') || default_cookie).filter_by_category,
      filter_by_language: ($cookies.get('all_tests_filters') || default_cookie).filter_by_language,
      filter_by_flexible_deadline: ($cookies.get('all_tests_filters') || default_cookie).filter_by_flexible_deadline,
      filter_by_difficulty: ($cookies.get('all_tests_filters') || default_cookie).filter_by_difficulty,
      filter_by_tech_edited: ($cookies.get('all_tests_filters') || default_cookie).filter_by_tech_edited
    },
    mounted: function() {
      const that = this
      $.ajax({
        url: '/pattern_tests/public_index.json',
        success: function(res) {
          that.open_tests = res;
        }
      });
    },
    watch: {
      perPage () { this.setPages(); },
      open_tests ()         { this.setPages(); },
      filter_by_test_or_sample ()    { this.setPages(); },
      filter_by_craft ()    { this.setPages(); },
      filter_by_category () { this.setPages(); },
      filter_by_language () { this.setPages(); },
      filter_by_flexible_deadline () { this.setPages(); },
      filter_by_difficulty ()        { this.setPages(); },
      filter_by_tech_edited ()       { this.setPages(); },
      sort_by ()                     { this.setPages(); },
    },
    methods: {
      sort: function(tests) {
        let sort_by = this.sort_by;

        let sorted = tests.sort(function(a, b){
          if(sort_by == "deadline_ASC") {
            return a.deadline_sortable - b.deadline_sortable;
          } else if(sort_by == "deadline_DESC") {
            return b.deadline_sortable - a.deadline_sortable;
          } else if(sort_by == "published_DESC") {
            return b.published_sortable - a.published_sortable;
          }
        });

        return sorted;
      },
      filter: function() {
        let tests = this.open_tests.slice(0);
        if(this.filter_by_test_or_sample != "") {
          tests = tests.filter(item => item.test_or_sample == this.filter_by_test_or_sample);
        }
        if(this.filter_by_craft != "") {
          tests = tests.filter(item => item.craft == this.filter_by_craft);
        }
        if(this.filter_by_category != "") {
          tests = tests.filter(item => item.category == this.filter_by_category);
        }
        if(this.filter_by_language != "") {
          tests = tests.filter(item => item.language == this.filter_by_language);
        }
        if(this.filter_by_flexible_deadline != "") {
          tests = tests.filter(item => item.deadline_flexible == this.filter_by_flexible_deadline);
        }
        if(this.filter_by_tech_edited != "") {
          tests = tests.filter(item => item.tech_edited == this.filter_by_tech_edited);
        }
        tests = tests.filter(item => this.filter_by_difficulty.indexOf(""+item.difficulty_int) >= 0);

        return this.sort(tests);
      },
      setPages: function() {
        $cookies.set('all_tests_filters', { perPage: this.perPage, sort_by: this.sort_by,
          filter_by_test_or_sample: this.filter_by_test_or_sample, filter_by_craft: this.filter_by_craft,
          filter_by_category: this.filter_by_category, filter_by_language: this.filter_by_language,
          filter_by_flexible_deadline: this.filter_by_flexible_deadline,
          filter_by_difficulty: this.filter_by_difficulty, filter_by_tech_edited: this.filter_by_tech_edited });

        this.pages = [];
        let tests = this.filter();
        if(this.perPage == 'All') {
          let numberOfPages = 1;
          this.pages.push(1);
        } else {
          let numberOfPages = Math.ceil(tests.length / this.perPage);
          for(let index=1; index <= numberOfPages; index++) {
            this.pages.push(index);
          }
        }
      },
      paginate: function(tests) {
        if(this.perPage == 'All') {
          return tests;
        } else {
          let page = this.page;
          let perPage = this.perPage;
          let from = (page * perPage) - perPage;
          let to = (page * perPage);
          return tests.slice(from, to);
        }
      },
    },
    computed: {
      displayedTests () {
        let tests = this.filter();
        return this.paginate(tests);
      }
    },
  })
})

